import { useEffect, useRef } from 'react';
import { getScrollContainer } from '../helpers/getScrollContainer';
import { hasScrollbar } from '../helpers/hasScrollbar';
export const useDisableScroll = (active) => {
    const settings = useRef({
        html: {
            scrollBehavior: '',
        },
        body: {
            scrollTop: 0,
            scrollBehavior: '',
            styles: '',
        },
    });
    useEffect(() => {
        const scrollContainer = getScrollContainer();
        const cleanup = () => {
            document.body.style.cssText = settings.current.body.styles;
            scrollContainer.scrollTop = settings.current.body.scrollTop;
            scrollContainer.style.scrollBehavior = settings.current.body.scrollBehavior;
            document.documentElement.style.scrollBehavior = settings.current.html.scrollBehavior;
        };
        if (active) {
            const hasVerticalScroll = hasScrollbar(scrollContainer);
            settings.current.html = {
                scrollBehavior: document.documentElement.style.scrollBehavior,
            };
            settings.current.body = {
                scrollTop: scrollContainer.scrollTop,
                scrollBehavior: scrollContainer.style.scrollBehavior,
                styles: document.body.style.cssText,
            };
            document.documentElement.style.scrollBehavior = 'auto';
            document.body.style.cssText = `; overflow-x: hidden; overflow-y: ${hasVerticalScroll ? 'scroll' : 'hidden'}; position: fixed; top: -${settings.current.body.scrollTop}px; height: 100%; width: 100%;`;
        }
        else {
            cleanup();
        }
        return () => {
            cleanup();
        };
    }, [active]);
};
